import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Contact } from './contact';
import {Observable, of} from 'rxjs';
import {delay, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { stringify } from 'querystring';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';

export interface HelpContactOrg {
  ID: string;
  Name: string;
  Mobile: string;
  State: string;
  City: string;
  typ: string;
}
@Injectable({
  providedIn: 'root'
})

@Component({
    selector: 'app-addorgcontact',
    templateUrl: './addorgcontact.component.html',
    styleUrls: ['./addorgcontact.component.css'],
    standalone: false
})

export class AddorgcontactComponent implements OnInit {
  ContactType: any;
  Company: any;
  Department: any;
  Department1: any;
  Designation: any;
  Agency: any;
  State: any;
  City: any;
  Court: any;
  url: string;
  pageurl: string;
  numb: any;
  id: any;
  typ: any;
  address: string;
  buttonname: string;
  pageHeader: string;
  contactName: string;
  mapOrganization: string;
  companyCode: string;
  HideOrganizationTr: string;
  disableButton: any;
  GenID: string;
  GID: string;
  MID: string;
  addFormContact: FormGroup;
  submitted: any;
  status: string;
  getdata: string;
  ContactOrgList: HelpContactOrg[] = [];
  selectedContactOrg = [];
  pagehead: any;
  ContactorOrg: string;
  disabled: boolean;
  RightsID: string;
  RouteCompany: string;
  RouteGMDesignation: string;
  RouteGMAgency: string;
  RouteGMDepartment: string;
  RouteGMState: string;
  RouteGMCity: string;
  RouteGMJurisdiction: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor( private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) {
    this.url = AppComponent.baseURL; }
  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');

    if (this.RightsID.includes('202034001') || this.RightsID.includes('202034021') || this.RightsID.includes('202034000')) {
    } else {
      window.location.href = "module/0";
    }
    this.fetchRouteDataRights();
    this.pageurl = this.router.url;
    this.pagehead = this.pageurl.split('/');
    this.id = this.pagehead[3];
    this.typ = this.pagehead[2];
    this.HideOrganizationTr = "!isHidden";
    this.getMasterData();
    this.getContactType();
    this.addFormContact = this.formBuilder.group({
      contactName: ['', Validators.required], Company: [null, Validators.required], Department: [null, Validators.required],
      Designation: [null, Validators.required], Departmentd: [null, Validators.required], address: ['', Validators.required], companycode: ['', Validators.required], Agency: [null, Validators.required],ContactType:[null], MobileNumber: ['', Validators.required],
      State: [null, Validators.required], workphone: [''], City: [null, Validators.required], workphone2: [''], Court: [null], faxno: [''], zipcode: [''],
      webPage: [''], email1: [''], email2: [''], Company1: [''], Companydetail: [''], MapContactOrg: ['']
     });
    //  this.addFormContact.patchValue({
    //    ContactType:1, Company: 0,Department: 0, Designation: 0, Departmentd: 0, Agency: 0, State: 0,
    //    City: 0, Court: 0
    //  });
    if (this.id == '0')  {
      this.ContactFetch();
    }
    if (this.id !== '0') {

      this.FetchExistingContactOrg();
    }
    this.submitted = false;
    if (this.typ=="1")
    {
      this.addFormContact.patchValue({
        Company: null,
        Department: null,
        Designation: null,
        Departmentd: null,
        Agency:  null,
        ContactType: '2' ,
        State:  null,
        City:  null,
        Court:  null
      });
    }
    else
    {
      this.addFormContact.patchValue({
        Company: null,
        Department: null,
        Designation: null,
        Departmentd: null,
        Agency:  null,
        ContactType: '1' ,
        State:  null,
        City:  null,
        Court:  null
      });
    }

   
  }
  get f() { return this.addFormContact.controls; }
  fetchRouteDataRights() {
    // tslint:disable-next-line: max-line-length
    this.RouteCompany = this.RightsID.includes('202044000') || this.RightsID.includes('202044001') || this.RightsID.includes('202044021') ? 'navcompany/company/0' : 'module/0';
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
     this.RouteGMDesignation = "general-master/035";
     this.RouteGMAgency = "general-master/040";
     this.RouteGMDepartment = "general-master/030";
     this.RouteGMState = "general-master/010";
     this.RouteGMCity = "general-master/015";
     this.RouteGMJurisdiction = "general-master/020";
    } else {
    this.RouteGMDesignation = "module/0";
    this.RouteGMAgency = "module/0";
    this.RouteGMDepartment  ="module/0";
    this.RouteGMState = "module/0";
    this.RouteGMCity = "module/0";
    this.RouteGMJurisdiction = "module/0"; }
    }
   ContactFetch()  {
    if (this.pagehead[2] === '0') {
      this.pageHeader = 'Add New Contact';
      this.buttonname = 'ADD';
      this.contactName = 'Contact Person Name';
      this.mapOrganization = 'Map Organization';
      this.companyCode = 'Customer Code';
      this.HideOrganizationTr = "";
      this.http.get(this.url + 'Help/FetchHelpContactOrg?Type=1')
      .subscribe( (data) =>   {
        if (data == null) {
          this.ContactOrgList = null;
        } else {
          this.ContactOrgList = JSON.parse(data.toString());
        }
      });
    }
    if (this.pagehead[2] === '1') {
      this.pageHeader = 'Add New Organization';
      this.buttonname = 'ADD';
      this.contactName = 'Organization Name';
      this.mapOrganization = 'Map Contacts';
      this.companyCode = 'Organization Code';
      this.http.get(this.url + 'Help/FetchHelpContactOrg?Type=0')
      .subscribe( (data) =>   {
        if (data == null) {
          this.ContactOrgList = null;
        } else {
          this.ContactOrgList = JSON.parse(data.toString());
        }
      });
    }

   }
  onStateSelect(value) {
    this.getMaster('015', value.hdID).subscribe( (data: any) => {
      this.City = data ;
      let data1: any;
      this.Court = data1; });
  }
  onCitySelect(value) {
    this.getMaster('020', value.hdID  ).subscribe( (data: any) => {
      this.Court = data; });
  }

  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
  getContactType(){
    this.http.get(this.url + 'Notice/GetContactType')
    .subscribe( (data) => {
      this.ContactType = JSON.parse(data.toString());});
    }
  getMasterData() {
     this.getMaster('030', '') .subscribe( (data: any) => {
      this.Department = data; });
     this.getMaster('040', '') .subscribe( (data: any) => {
      this.Agency = data; });
     this.getMaster('010', '') .subscribe( (data: any) => {
      this.State = data; });
     this.getMaster('035', '') .subscribe( (data: any) => {
      this.Designation = data; });
     this.http.get(this.url + 'Notice/GetCompanyMasterList') .subscribe( (data) => {
        this.Company = JSON.parse(data.toString()); });
  }

  onClickSubmit(formData1) {
    this.submitted = true;
    if (this.addFormContact.invalid) { 
      this.addFormContact.markAllAsTouched();
      return; }
    let pagehead1 = this.router.url.split('/');
    this.disableButton = true;
    this.numb = 1;
    let Contact1: Contact = {
      Title: '0',
      Name: formData1.contactName,
      Address: formData1.address,
      StateID: formData1.State,
      CityID: formData1.City,
      CourtID: formData1.Court,
      Zip: formData1.zipcode,
      Email1: formData1.email1,
      Email2: formData1.email2,
      CompanyID: formData1.Company,
      DeptID: formData1.Department,
      AgencyID: formData1.Agency,
      ContactTypeID: formData1.ContactType,
      CustomerCode: formData1.companycode,
      DesignationID:  formData1.Designation,
      DeptID2: formData1.Departmentd,
      Mobile: formData1.MobileNumber,
      WorkPhone1: formData1.workphone,
      WorkPhone2: formData1.workphone2,
      Fax: formData1.faxno,
      WebSite: formData1.webPage,
      recEnable: this.numb,
      recUser: this.numb,
      recAddUser: this.numb,
      type: this.typ,
      id: this.id,
      MappedWithContactID: formData1.MapContactOrg.toString()
    };
    this.http.post (this.url + 'ContactOrg/insertUpdateContact', Contact1) .subscribe( (data) => {
    if (data === null) {
      this.alertService.showError('Contact Add Failed');
         this.disableButton = false;
       } else  {
        if (this.id == "0") {
          if (this.pagehead[2] === '0') {
            this.alertService.showSuccess('Contact Added Successfully');
          }
          else
          this.alertService.showSuccess('Organization Added Successfully');
        } else {
          if (this.pagehead[2] === '0') {
            this.alertService.showSuccess('Contact Updated Successfully');
          }
          else
          this.alertService.showSuccess('Organization Updated Successfully');
        }
        data = data.toString().split(':');
        this.getdata = data[1].toString().split('}');
        this.id = this.getdata[0].toString();
        this.buttonname = 'Update';
        this.disableButton = false;
       }
     }
   );
  }

  FetchExistingContactOrg() {
      this.http.get(this.url + 'ContactOrg/FetchExistingContactOrg?ID=' + this.id)
      .subscribe( (data) =>   {
          if (data == null) {
            this.alertService.showError('No Record Exist');
          } else {
            const fetchContactdata: Contact = JSON.parse(data.toString())[0];
            if (fetchContactdata.type == '1') {
              this.pageHeader = 'Update Organization';
              this.buttonname = 'Update';
              this.contactName = 'Organization Name';
              this.mapOrganization = 'Map Contacts';
              this.companyCode = 'Organization Code';
              this.ContactorOrg = "0";
            } else if ( fetchContactdata.type == '0') {
              this.pageHeader = 'Update Contact';
              this.buttonname = 'Update';
              this.contactName = 'Contact Person Name* ';
              this.mapOrganization = 'Map Organization';
              this.companyCode = 'Customer Code';
              this.ContactorOrg = "1";
              this.HideOrganizationTr = "";
            }
            if (fetchContactdata.StateID != null) {
              // tslint:disable-next-line: max-line-length
              this.getMaster('015', fetchContactdata.StateID.toString()).subscribe( (data: any) => { this.City = data ; let data1: any; this.Court = data1; }); }
            if (fetchContactdata.CityID != null) {
              this.getMaster('020', fetchContactdata.CityID.toString()).subscribe( (data: any) => { this.Court = data; }); }
            this.http.get(this.url + 'Help/FetchHelpContactOrg?Type=' + this.ContactorOrg)
            .subscribe( (data) =>   {
              if (data == null) {
                this.ContactOrgList = null;
              } else {
                this.ContactOrgList = JSON.parse(data.toString());
                if (fetchContactdata.MappedWithContactID != null) {
                this.selectedContactOrg = fetchContactdata.MappedWithContactID.toString().split(',').map(Number); }
              }
            });
            this.addFormContact.patchValue({
              contactName: fetchContactdata.Name,
              Company: fetchContactdata.CompanyID == null ? 0 : fetchContactdata.CompanyID,
              Department: fetchContactdata.DeptID == null ? 0 : fetchContactdata.DeptID,
              Designation: fetchContactdata.DesignationID == null ? 0 : fetchContactdata.DesignationID,
              Departmentd: fetchContactdata.DeptID2 == null ? 0 : fetchContactdata.DeptID2,
              address: fetchContactdata.Address,
              companycode: fetchContactdata.CustomerCode,
              Agency: fetchContactdata.AgencyID == null ? 0 : fetchContactdata.AgencyID,
              ContactType: fetchContactdata.ContactTypeID == null ? 1 : fetchContactdata.ContactTypeID,
              MobileNumber: fetchContactdata.Mobile,
              State: fetchContactdata.StateID == null ? 0 : fetchContactdata.StateID,
              workphone: fetchContactdata.WorkPhone1,
              City: fetchContactdata.CityID == null ? 0 : fetchContactdata.CityID,
              workphone2: fetchContactdata.WorkPhone2,
              Court: fetchContactdata.CourtID == null ? 0 : fetchContactdata.CourtID,
              faxno: fetchContactdata.Fax,
              zipcode: fetchContactdata.Zip,
              webPage: fetchContactdata.WebSite,
              email1: fetchContactdata.Email1,
              email2: fetchContactdata.Email2,
              MapContactOrg: fetchContactdata.MappedWithContactID?.split(',').map(Number).filter(val => val != null)
            });
          }
         }
      );
    }
  goBack() {
    window.history.back();
  }
}
